<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title fxLayoutAlign="space-between" class="panel-title">

      <div fxLayout="row" fxLayoutAlign="space-between center">

        <div class="student-name">  
            {{ studentData.StudentName }}
        </div>
      
        <div class="grade">
          {{studentData.Grade}}
        </div>

        <div class="progress-container" *ngIf="studentData.LessonsAssigned">
          <div class="progressbar-text" >
            {{ completionPercentage }}%
            &nbsp; ({{studentData.LessonsCompleted}} / {{studentData.LessonsAssigned}})
            &nbsp; (Average:  {{studentData.AverageILPGrade ? studentData.AverageILPGrade : '-'}})
          </div>
          <div class="progressbar" [ngClass]="(completionPercentage >= 50) ? 'success' : 'failure'">
            <span [style.width]="completionPercentage+'%'"></span>
          </div>
        </div>

      </div>

      <div fxLayout="row" fxLayoutAlign="flex-start center" *ngIf="studentData.LessonsAssigned">
        <div>
          Last Submitted <span class="latest-date">{{ studentData.LastSubmittedDate }}</span>
        </div>
        <div class="needs-attention" [ngClass]="(studentData.NeedsAttentionCount === 0) ? 'no-attention' : 'attention'">
          {{ studentData.NeedsAttentionCount }}
        </div>

      </div>

    </mat-panel-title>
  </mat-expansion-panel-header>

  <div fxLayout="column">

    <div fxLayoutAlign="end end">

       <!-- Table legend describing cell color  -->
      <div *ngIf="studentData.LessonsAssigned" fxFlex fxLayout="row" fxLayoutAlign="space-around" class="color-indicator-container" fxLayoutGap="15px grid">
        <div>
          <mat-button-toggle-group value="-1">
            <mat-button-toggle (click)="filterILP(-1)" value="-1">
              <span class="status-label"> All Assignments</span>
               
            </mat-button-toggle>

          <mat-button-toggle *ngFor="let colorIndicator of colorIndicators; let i = index" (click)="filterILP(i)">
            <span class="status-color" [ngStyle]="{'background-color': colorIndicator.color}">
            </span>
            <span class="status-label">
              {{ colorIndicator.label }}
            </span>
          </mat-button-toggle>

          </mat-button-toggle-group>
        </div>
      </div>

      <button mat-button 
        class="outline-btn btn-blue"
        (click)="$event.stopPropagation(); openReleaseAllLessonsDialog()" *ngIf="studentData.LessonsAssigned">
        Release All Assignments
      </button>
      <button mat-button 
        class="outline-btn btn-blue"
        (click)="$event.stopPropagation(); openUnassignAllLessonsDialog()" *ngIf="studentData.LessonsAssigned">
        Unassign All Assignments
      </button>


    </div>
 
    <div class="panel-body" fxLayout="row wrap" fxLayoutAlign="space-around center" fxLayoutGap="35px grid">
    

      <div fxLayout="column" fxLayoutAlign="center center" *ngIf="!studentData.LessonsAssigned">
        There were no Diagnostic assignments for this student.

        <br>

        <button mat-button 
        class="outline-btn-remove btn-blue"
        (click)="$event.stopPropagation(); removeStudentFromSkipList()" 
        *ngIf="!studentData.LessonsAssigned">
        Remove assignment placeholder record
        </button>

      </div>



      <div *ngFor="let assignment of studentData.Assignments">
        <assignment-card-brief 
        [assignment]="assignment" 
        [studentID]="studentData.StudentID" 
        [studentName]="studentData.StudentName"
        [classID]="classID"
        [diagExamID]="diagExamID"
        (unassigned)="unassignDiagnosticLesson($event)"></assignment-card-brief>
      </div>

    </div>

  </div>

</mat-expansion-panel>
